export default {
"type": "FeatureCollection",
"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
"features": [
{ "type": "Feature", "properties": { "nom": "Capella de Sant Miquel", "image": "./Imatges/Capella_SantMiquel.png" }, "geometry": { "type": "Point", "coordinates": [ 1.841546151477388, 41.586792827332502 ] } },
{ "type": "Feature", "properties": { "nom": "Capella de Sant Joan", "image": "./Imatges/Capella_SantJoan.png" }, "geometry": { "type": "Point", "coordinates": [ 1.82773556718284, 41.586971984444439 ] } },
{ "type": "Feature", "properties": { "nom": "Capella de Sant Jeroni" , "image": "./Imatges/Capella_SantJeroni.png"}, "geometry": { "type": "Point", "coordinates": [ 1.813478782061038, 41.604355830714496 ] } }
]
}
